/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Professional_Select_PositionInputs */



/**
* | output |
* | --- |
* | "Select position..." |
*
* @param {Profile_Professional_Select_PositionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_professional_select_position = /** @type {((inputs?: Profile_Professional_Select_PositionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Professional_Select_PositionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Position auswählen...")
	return /** @type {LocalizedString} */ ("Select position...")
});